/* tslint:disable */
/* eslint-disable */
/**
 * Ак Барс Недвижимость API
 * Инструменты разработчика:  [ [Документация API. Swagger](/docs/) ]  [ [Документация API. Redoc](/redoc/) ] [ [Панель администрирования](/admin/) ] [ [Документация Image-Service](/api/attachments/docs/) ]
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChangeOwner
 */
export interface ChangeOwner {
    /**
     * 
     * @type {string}
     * @memberof ChangeOwner
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof ChangeOwner
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof ChangeOwner
     */
    patronymicName?: string;
    /**
     * 
     * @type {string}
     * @memberof ChangeOwner
     */
    type?: string;
    /**
     * 
     * @type {Date}
     * @memberof ChangeOwner
     */
    birthday?: Date;
    /**
     * 
     * @type {number}
     * @memberof ChangeOwner
     */
    percent?: number;
    /**
     * 
     * @type {number}
     * @memberof ChangeOwner
     */
    readonly id?: number;
    /**
     * 
     * @type {number}
     * @memberof ChangeOwner
     */
    readonly deal?: number;
    /**
     * 
     * @type {number}
     * @memberof ChangeOwner
     */
    readonly user?: number;
    /**
     * 
     * @type {number}
     * @memberof ChangeOwner
     */
    readonly contact?: number;
    /**
     * 
     * @type {Date}
     * @memberof ChangeOwner
     */
    readonly createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ChangeOwner
     */
    readonly updatedAt?: Date;
}

export function ChangeOwnerFromJSON(json: any): ChangeOwner {
    return ChangeOwnerFromJSONTyped(json, false);
}

export function ChangeOwnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChangeOwner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'lastName': !exists(json, 'lastName') ? undefined : json['lastName'],
        'firstName': !exists(json, 'firstName') ? undefined : json['firstName'],
        'patronymicName': !exists(json, 'patronymicName') ? undefined : json['patronymicName'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'birthday': !exists(json, 'birthday') ? undefined : (new Date(json['birthday'])),
        'percent': !exists(json, 'percent') ? undefined : json['percent'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'deal': !exists(json, 'deal') ? undefined : json['deal'],
        'user': !exists(json, 'user') ? undefined : json['user'],
        'contact': !exists(json, 'contact') ? undefined : json['contact'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
    };
}

export function ChangeOwnerToJSON(value?: ChangeOwner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'lastName': value.lastName,
        'firstName': value.firstName,
        'patronymicName': value.patronymicName,
        'type': value.type,
        'birthday': value.birthday === undefined ? undefined : (value.birthday.toISOString().substr(0,10)),
        'percent': value.percent,
    };
}


